<script lang="ts" setup>
  import { useAuthenticated } from '@othercommerce/foundation';

  const authenticated = useAuthenticated();
</script>
<template>
  <SfButton :href="authenticated ? $route('web.account.wishlist.index') : $route('web.account.session.create')" transparent>
    <template #before>
      <SfIconHeart aria-hidden="true" />
    </template>
    <template #default>
      {{ $t('SHOP.COMMON.ACTION.WISHLISTS') }}
    </template>
  </SfButton>
</template>
